import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import request from "./request"; // 引入axios的封装方法
var baseApi = 'webApi/bop-staff/v1/bop-staff';
/** 员工管理*/
/** 查询自然人信息 */
export var queryPartyByIdApi = function queryPartyByIdApi(partyId) {
  return request('get', "".concat(baseApi, "/party/").concat(partyId));
};

/** 更新自然人基础信息 */
export var updatePartyByIdApi = function updatePartyByIdApi(partyId, params) {
  return request('put', "".concat(baseApi, "/party/").concat(partyId), params);
};
// 新增参与人教育经历
export var addPartyEducationApi = function addPartyEducationApi(partyId, params) {
  return request('post', "".concat(baseApi, "/party/").concat(partyId, "/educationResume"), params);
};
// 修改参与人教育经历
export var updatePartyEducationApi = function updatePartyEducationApi(partyId, educationResumeId, params) {
  return request('put', "".concat(baseApi, "/party/").concat(partyId, "/educationResume/").concat(educationResumeId), params);
};
// 删除参与人教育经历
export var deletePartyEducationApi = function deletePartyEducationApi(partyId, educationResumeId) {
  return request('delete', "".concat(baseApi, "/party/").concat(partyId, "/educationResume/").concat(educationResumeId));
};
// 新增参与人教育经历
export var addPartyWorkApi = function addPartyWorkApi(partyId, params) {
  return request('post', "".concat(baseApi, "/party/").concat(partyId, "/workResume"), params);
};
// 修改参与人教育经历
export var updatePartyWorkApi = function updatePartyWorkApi(partyId, workResumeId, params) {
  return request('put', "".concat(baseApi, "/party/").concat(partyId, "/workResume/").concat(workResumeId), params);
};
// 删除参与人教育经历
export var deletePartyWorkApi = function deletePartyWorkApi(partyId, workResumeId) {
  return request('delete', "".concat(baseApi, "/party/").concat(partyId, "/workResume/").concat(workResumeId));
};
// 新增员工的紧急联系人
export var addStaffEmergencyApi = function addStaffEmergencyApi(staffId, params) {
  return request('post', "".concat(baseApi, "/staff/").concat(staffId, "/emergencyContact"), params);
};
// 修改员工的紧急联系人
export var updateStaffEmergencyApi = function updateStaffEmergencyApi(staffId, contactId, params) {
  return request('put', "".concat(baseApi, "/staff/").concat(staffId, "/emergencyContact/").concat(contactId), params);
};
// 删除员工的紧急联系人
export var deleteStaffEmergencyApi = function deleteStaffEmergencyApi(staffId, contactId) {
  return request('delete', "".concat(baseApi, "/staff/").concat(staffId, "/emergencyContact/").concat(contactId));
};
// 新增员工的联系人
export var addStaffContactApi = function addStaffContactApi(staffId, params) {
  return request('post', "".concat(baseApi, "/staff/").concat(staffId, "/contact"), params);
};
// 修改员工的联系人
export var updateStaffContactApi = function updateStaffContactApi(staffId, contactId, params) {
  return request('put', "".concat(baseApi, "/staff/").concat(staffId, "/contact/").concat(contactId), params);
};
// 删除员工的联系人
export var deleteStaffContactApi = function deleteStaffContactApi(staffId, contactId) {
  return request('delete', "".concat(baseApi, "/staff/").concat(staffId, "/contact/").concat(contactId));
};
// 删除员工的联系人
export var updateStaffDutyApi = function updateStaffDutyApi(staffId, params) {
  return request('put', "".concat(baseApi, "/staff/").concat(staffId, "/staffDuties"), params);
};
// 批量修改员工材料信息
export var updateStaffMaterialsApi = function updateStaffMaterialsApi(staffId, params) {
  return request('post', "".concat(baseApi, "/staff/").concat(staffId, "/materials"), params);
};
// // 创建员工材料信息
// export const createStaffMaterialApi = (staffId, params) => {
//   return request('post', `${baseApi}/staff/${staffId}/material`, params);
// };
// // 创建员工材料信息
// export const updateStaffMaterialApi = (staffId, materialId, params) => {
//   return request('post', `${baseApi}/staff/${staffId}/material/${materialId}`, params);
// };
/** */
export var queryStaffApi = function queryStaffApi(params) {
  return request('get', "".concat(baseApi, "/staff"), params);
};
/** */
export var queryStaffInfoByIdApi = function queryStaffInfoByIdApi(id) {
  return request('get', "".concat(baseApi, "/staff/").concat(id));
};
// 创建员工接口
export var createStaffApi = function createStaffApi(params) {
  return request('post', "".concat(baseApi, "/staff"), params);
};
// 分页查询员工列表信息接口
export var getStaffListApi = function getStaffListApi(params) {
  if (params && typeof params.departmentIds === 'undefined') {
    params['departmentIds'] = params.departmentId;
  }
  return request('get', "".concat(baseApi, "/staff"), params);
};
// 查询员工详细信息接口
export var getStaffInfoApi = function getStaffInfoApi(id) {
  return request('get', "".concat(baseApi, "/staff/").concat(id));
};
// 修改员工接口
export var updateStaffInfoApi = function updateStaffInfoApi(params) {
  return request('put', "".concat(baseApi, "staff"), params);
};
/** */
export var updateStaffApi = function updateStaffApi(params) {
  var id = params.staffDto.id;
  return request('put', "".concat(baseApi, "/staff/").concat(id), params);
};
// 通过操作员operatorCode查询员工详情
export var queryStaffInfoByOperatorCodeApi = function queryStaffInfoByOperatorCodeApi(operatorCode) {
  return request('get', "".concat(baseApi, "/ext/staff/").concat(operatorCode));
};

// 查询主体信息
export var querySubjectInfoApi = function querySubjectInfoApi(id) {
  return request('get', "webApi/bop-organization/v1/bop-organization/organization/".concat(id, "/subject"));
};
// 创建组织信息
export var createOrganizationApi = function createOrganizationApi(params) {
  return request('post', "webApi/bop-organization/v1/bop-organization/organization", params);
};

// 更新组织信息
export var updateOrganizationApi = function updateOrganizationApi(params) {
  var organizationId = params.id;
  return request('put', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId), params);
};

// 获取组织分页信息
export var queryOrganizationPageApi = function queryOrganizationPageApi(params) {
  return request('get', "webApi/bop-organization/v1/bop-organization/organization", params);
};
// 获取组织信息
export var queryOrganizationInfoApi = function queryOrganizationInfoApi(organizationId) {
  return request('get', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId));
};

// 获取组织信息
export var queryExtDepartmentApi = function queryExtDepartmentApi(departmentId) {
  return request('get', "webApi/bop-organization/v1/bop-organization/ext/department/".concat(departmentId));
};
export var queryExtDepartmentWithChildrenApi = function queryExtDepartmentWithChildrenApi(params) {
  var organizationId = params.organizationId;
  return request('get', "webApi/bop-organization/v1/bop-organization/ext/organization/".concat(organizationId, "/department"), params);
};
// 修改组织信息
export var editOrganizationApi = function editOrganizationApi(organizationId, params) {
  return request('put', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId), params);
};
// 查询部门信息
export var queryDepartmentApi = function queryDepartmentApi(params) {
  var organizationId = params.organizationId,
    departmentId = params.departmentId;
  return request('get', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId, "/department/").concat(departmentId), params);
};
// 修改部门信息
export var editDepartmentApi = function editDepartmentApi(params) {
  var organizationId = params.organizationId,
    departmentId = params.departmentId;
  return request('put', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId, "/department/").concat(departmentId), params);
};
// 获取部门分页信息
export var queryDepartmentPageApi = function queryDepartmentPageApi(organizationId, params) {
  return request('get', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId, "/department"), params);
};
// 根据部门ID和组织ID查询对应部门接口
export var queryDepartmentInfoApi = function queryDepartmentInfoApi(organizationId, departmentId) {
  // ${params.orgId}
  return request('get', "webApi/bop-organization/v1/bop-organization/organization/".concat(organizationId, "/department/").concat(departmentId));
};
// 查询角色列表信息
export var queryRoleListApi = function queryRoleListApi(params) {
  return request('get', "webApi/bop-organization/v1/bop-role/ext/role", params);
};
// 通过条件查询角色下的员工分页列表
// 通过条件查询可分配角色的员工列表
export var queryStaffByRoleApi = function queryStaffByRoleApi(params) {
  return request('get', "webApi/bop-staff/v1/bop-staff/ext/staff/ext", params);
};
// 为角色批量添加员工
export var addStaffs4RoleApi = function addStaffs4RoleApi(roleId, params) {
  return request('post', "webApi/bop-staff/v1/bop-staffRole/ext/role/".concat(roleId, "/staffRole"), params);
};
// 删除员工角色关系-角色和员工的关系id
export var deleteRole4StaffApi = function deleteRole4StaffApi(staffRoleId) {
  return request('delete', "webApi/bop-staff/v1/bop-staffRole/ext/staff/staffRole/".concat(staffRoleId));
};
// 分页查询角色列表信息
export var queryRoleListPageApi = function queryRoleListPageApi(params) {
  return request('get', "webApi/bop-organization/v1/bop-role/role", params);
};
// 创建人力角色
export var addRoleApi = function addRoleApi(data) {
  return request('post', "webApi/bop-organization/v1/bop-role/role", data);
};
// 修改人力角色
export var modifyRoleApi = function modifyRoleApi(data) {
  var id = data.id;
  return request('put', "webApi/bop-organization/v1/bop-role/role/".concat(id), data);
};
// 修改角色
export var editRoleListApi = function editRoleListApi(roleId, params) {
  return request('put', "webApi/bop-role/v1/bop-role/role/".concat(roleId), params);
};
// 获取岗位列表
export var getPositionApi = function getPositionApi(params) {
  return request('get', "webApi/bop-position/v1/bop-position/position", params);
};
// 获取岗位信息
export var getPositionInfoApi = function getPositionInfoApi(id) {
  return request('get', "webApi/bop-position/v1/bop-position/position/".concat(id));
};
// 查询职务列表接口
export var getPostListApi = function getPostListApi(params) {
  return request('get', "webApi/bop-position/v1/bop-post/post", params);
};
// 创建职务接口
export var creatPostApi = function creatPostApi(params) {
  return request('post', "webApi/bop-position/v1/bop-post/post", params);
};
// 更新职务接口
export var updataPostApi = function updataPostApi(id) {
  return request('put', "webApi/bop-position/v1/bop-post/post/".concat(id));
};
// 根据ID查询职务接口
export var getPostInfoApi = function getPostInfoApi(id) {
  return request('get', "webApi/bop-position/v1/bop-post/post/".concat(id));
};
// 查询职责列表接口
export var getDutyListApi = function getDutyListApi(params) {
  return request('get', "webApi/bop-duty/v1/bop-duty/duty", params);
};
// 查询字典列表接口
export var getDictionaryApi = function getDictionaryApi(params) {
  return request('get', "webApi/bop-dictionary/v1/bop-dictionary/dictionary", params);
};
// 创建业务单
export var queryBusinessPageApi = function queryBusinessPageApi(params) {
  return request('get', "webApi/bop-staff-business/v1/bop-staff-business/business", params);
};

// 扩展extTransExtOrgId
function extTransExtOrgId(_x) {
  return _extTransExtOrgId.apply(this, arguments);
} // 扩展extOrgId;
function _extTransExtOrgId() {
  _extTransExtOrgId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    var transDepartmentId, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            transDepartmentId = params.businessOrderDto && params.businessOrderDto.businessOrderDetailsDto && params.businessOrderDto.businessOrderDetailsDto.transDepartmentId;
            if (!(transDepartmentId && transDepartmentId.length > 0)) {
              _context3.next = 7;
              break;
            }
            _context3.next = 4;
            return queryExtDepartmentApi(transDepartmentId);
          case 4:
            response = _context3.sent;
            params.businessOrderDto['transExtOrgId'] = response.data && response.data.extOrgId;
            params.businessOrderDto.businessOrderDetailsDto['transExtOrgId'] = response.data && response.data.extOrgId;
          case 7:
            return _context3.abrupt("return", params);
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _extTransExtOrgId.apply(this, arguments);
}
function extOrgId(_x2) {
  return _extOrgId.apply(this, arguments);
} // 创建业务单
function _extOrgId() {
  _extOrgId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    var departmentId, response, extTransParams;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            departmentId = params.businessOrderDto && params.businessOrderDto.businessOrderDetailsDto && params.businessOrderDto.businessOrderDetailsDto.departmentId;
            if (!(departmentId && departmentId.length > 0)) {
              _context4.next = 7;
              break;
            }
            _context4.next = 4;
            return queryExtDepartmentApi(departmentId);
          case 4:
            response = _context4.sent;
            params.businessOrderDto['extOrgId'] = response.data && response.data.extOrgId;
            params.businessOrderDto.businessOrderDetailsDto['extOrgId'] = response.data && response.data.extOrgId;
          case 7:
            _context4.next = 9;
            return extTransExtOrgId(params);
          case 9:
            extTransParams = _context4.sent;
            return _context4.abrupt("return", extTransParams);
          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _extOrgId.apply(this, arguments);
}
export var createBusinessApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var extParams, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return extOrgId(params);
          case 2:
            extParams = _context.sent;
            _context.next = 5;
            return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business", extParams);
          case 5:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function createBusinessApi(_x3) {
    return _ref.apply(this, arguments);
  };
}();
// 修改业务单
export var updateBusinessApi = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    var extParams, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return extOrgId(params);
          case 2:
            extParams = _context2.sent;
            _context2.next = 5;
            return request('put', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(params.businessOrderDto.id), extParams);
          case 5:
            response = _context2.sent;
            return _context2.abrupt("return", response);
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function updateBusinessApi(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
// 删除业务单草稿
export var deleteBusinessApi = function deleteBusinessApi(id) {
  return request('delete', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(id));
};
// 启动审批流程接口
export var submitStartProcessNewApi = function submitStartProcessNewApi(params) {
  var startProcessDto = params.startProcessDto;
  var businessOrderId = startProcessDto.businessOrderId;
  return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(businessOrderId, "/startProcess"), params);
};
// 启动审批流程接口
export var submitStartProcessApi = function submitStartProcessApi(params) {
  var Id = params.Id;
  return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(Id, "/startProcess"), params);
};

// 添加业务单日志
export var addComment4BusinessApi = function addComment4BusinessApi(id, params) {
  return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(id, "/businessOrderComment"), params);
};

// 删除业务
export var deleteBusinessByIdApi = function deleteBusinessByIdApi(id) {
  return request('delete', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(id));
};

// 查询业务单详细信息接口
export var getBusinessDetailApi = function getBusinessDetailApi(params) {
  return request('get', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(params));
};
// 分页查询业务单
export var getBusinessApi = function getBusinessApi(params) {
  return request('get', "webApi/bop-staff-business/v1/bop-staff-business/business", params);
};
// 查询员工详细信息接口
export var getStaffDetailApi = function getStaffDetailApi(params) {
  return request('get', "".concat(baseApi, "/staff/").concat(params));
};
// 创建入职合同
export var createEntryContractApi = function createEntryContractApi(data) {
  return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(data.businessOrderEntryContractDto.businessOrderId, "/entry/businessOrderEntryContract"), data);
};
// 创建入职登记单
export var createRegisterApi = function createRegisterApi(data) {
  return request('post', "webApi/bop-staff-business/v1/bop-staff-business/business/".concat(data.businessOrderRegisterDto.businessOrderId, "/entry/businessOrderRegister"), data);
};
// 员工业务扩展模块 修改入职业务单中信息
export var editBusinessInfoApi = function editBusinessInfoApi(businessId, data) {
  return request('put', "webApi/bop-staff-business/v1/bop-staff-business/ext/business/".concat(businessId, "/entry"), data);
};
// 员工业务扩展模块 通过外部编码查询员工详情
export var getStaffInfoByExtCodeApi = function getStaffInfoByExtCodeApi(extCode) {
  return request('get', "webApi/bop-staff/v1/bop-staff/ext/staff/".concat(extCode));
};
// 员工业务扩展模块 修改员工本身信息
export var editStaffInfoApi = function editStaffInfoApi(staffId, data) {
  return request('put', "webApi/bop-staff/v1/bop-staff/ext/staff/".concat(staffId), data);
};